import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { ReportBuilderDimension, useDimensions } from '@models/reportBuilder';
import { usePipelineNodes } from '@stores/data.store';
import LoadingCard from '@components/card/LoadingCard.component';
import PipelineNodeName from '@components/pipelineNodes/PipelineNodeName.component';

interface DimensionsListProps {
    dimensionFilter?: (dimension: ReportBuilderDimension) => boolean;
    searchQuery?: string;
}

const DimensionsList = (props: DimensionsListProps) => {
    const dimensions = useDimensions();
    const pipelineNodes = usePipelineNodes();

    const sortedDimensions = useMemo(() => {
        if (!dimensions.data) {
            return [];
        }

        return dimensions.data.filter(d => {
            if (props.dimensionFilter && !props.dimensionFilter(d)) {
                return false;
            }
            return d.name.toLowerCase().indexOf(props.searchQuery?.toLowerCase() || '') >= 0;
        }).sort((a, b) => {
            return a.name.localeCompare(b.name);
        });
    }, [dimensions.dataUpdatedAt, props.searchQuery, props.dimensionFilter]);

    if (dimensions.isLoading) {
        return <LoadingCard/>
    }

    return <>
        <table className="table table-bordered table-centered table-fixed mb-5">
            <thead className="bg-light">
                <tr>
                    <th style={{width: '25%'}}>Dimension Name</th>
                    <th style={{width: '25%'}}>Entity</th>
                    <th style={{width: '35%'}}>Description</th>
                    <th style={{width: '15%'}}>Actions</th>
                </tr>
            </thead>
            <tbody>
                {sortedDimensions.map(dimension => {
                    const pipelineNode = pipelineNodes.data?.find(n => n.id === dimension.pipeline_node_id);
                    return <tr key={dimension.id}>
                        <td>
                            {dimension.name}
                        </td>
                        <td>
                            {pipelineNode ? (
                                <Link to={`/node/${pipelineNode.id}`}>
                                    <PipelineNodeName pipelineNodeId={dimension.pipeline_node_id} />
                                </Link>
                            ) : (
                                <span className="text-muted">Unknown</span>
                            )}
                        </td>
                        <td>{dimension.description || '-'}</td>
                        <td>
                            <Link to={`/model/dimension/${dimension.id}`} className="btn btn-light btn-sm">
                                <i className="mdi mdi-cog"></i> Configure
                            </Link>
                        </td>
                    </tr>
                })}
            </tbody>
        </table>
    </>
}

export default DimensionsList;

